import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import MotiveTitle from '../../../Contact/Motive/MotiveTitle';
import ProductPreview from '../../../../common/ProductPreview';
import AppInput from '../../../../common/AppInput';
import DatePickers from '../../../../common/DatePickers';
import RadioOptions from '../../../../common/RadioOptions';
import Message from '../../../../common/Message';
import Loader from '../../../../common/Loader';
import { textMapper } from '../../../../../helpers/FormHelper';
import { COMPLETE_FORM } from '../../../../../constants/texts';
import { useNotReceivedStyles } from './styles';
import { optionsRadio } from './validation/fields';

const Form = ({ ...props }) => {
  const { state, onData, fields, motiveId, mobile, setShowForm } = props;
  const { status, messages, getStatus } = useSelector(
    (state) => state.validationProductSlice,
  );
  const [motiveClient, setMotiveClient] = useState('');
  const classes = useNotReceivedStyles({ mobile });
  const showMessage = messages.length > 0;
  const loadingGif = getStatus === 'loading';

  useEffect(() => {
    setShowForm(status);
  }, [status]);

  useEffect(() => {
    if (loadingGif) setShowForm(false);
    else setShowForm(status);
  }, [loadingGif]);

  const handleChange = (e) => {
    onData({ name: e.target.name, value: e.target.value });
  };

  const handleDate = (date) => {
    onData({ name: 'purchaseDate', value: date });
  };

  const handleRadio = (e) => {
    onData({ name: e.target.name, value: e.target.value });
    setMotiveClient(e.target.value);
  };

  return (
    <React.Fragment>
      <MotiveTitle
        title={textMapper.get(motiveId).title}
        subtitle={textMapper.get(motiveId).subtitle}
        icon={textMapper.get(motiveId).icon}
        mobile={mobile}
      />

      {loadingGif && <Loader mobile={mobile} />}

      {!loadingGif && (
        <React.Fragment>
          <ProductPreview mobile={mobile} />

          {showMessage && (
            <Message
              severity="info"
              mobile={mobile}
              message={messages}
              fullRounded
            />
          )}

          {status && (
            <React.Fragment>
              {optionsRadio.map((option, index) => (
                <RadioOptions
                  key={index}
                  onChange={handleRadio}
                  options={option}
                  name={option.name}
                  motiveClient={motiveClient}
                  mobile={mobile}
                  error={state[option.name]?.error || false}
                />
              ))}
              <Typography className={classes.title}>{COMPLETE_FORM}</Typography>
              {fields.map((field, index) => (
                <React.Fragment key={index}>
                  {!field.hidden && field.inputType !== 'date' && (
                    <AppInput
                      onChange={handleChange}
                      onBlur={() => {}}
                      onClick={() => {}}
                      disabled={state[field.name]?.disabled || false}
                      name={field.name}
                      error={state[field.name]?.error || false}
                      type={state[field.name]?.type || ''}
                      label={state[field.name]?.label || ''}
                      required={state[field.name]?.required || false}
                      inputAdornment={state[field.name]?.inputAdornment || ''}
                      success={state[field.name]?.success || ''}
                      helperText={state[field.name]?.helper || ''}
                      multiline={state[field.name]?.multiline || false}
                      rows={state[field.name]?.rows || ''}
                      value={state[field.name]?.value || ''}
                      errorMessage={state[field.name]?.message || ''}
                    />
                  )}
                  {!field.hidden && field.inputType === 'date' && (
                    <DatePickers
                      onChange={handleDate}
                      name={field.name}
                      label={state[field.name]?.label || ''}
                      required={state[field.name]?.required || false}
                      disabled={state[field.name]?.disabled || false}
                      success={state[field.name]?.success || ''}
                      error={state[field.name]?.error || false}
                      errorMessage={state[field.name]?.message || ''}
                      value={state[field.name]?.value || ''}
                      helperText={state[field.name]?.helper || ''}
                    />
                  )}
                </React.Fragment>
              ))}
            </React.Fragment>
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

Form.propTypes = {
  state: PropTypes.object,
  onData: PropTypes.func,
  fields: PropTypes.array,
  motiveId: PropTypes.string,
  mobile: PropTypes.bool,
  setShowForm: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
};

export default Form;
